module.exports = __webpack_public_path__ + "assets/images/premium-features/mobile-tc-616700.png";